import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Eye, X, ArrowLeft, User, Shield } from 'lucide-react';

export default function ImpersonationBanner() {
  const { isImpersonating, impersonatedUser, originalAdmin, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const handleReturn = () => {
    stopImpersonation();
    navigate('/admin/kullanicilar');
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-gradient-to-r from-amber-600 to-orange-600 text-white py-2 px-4 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Eye className="w-5 h-5" />
          <span className="font-medium">
            <span className="opacity-75">Görüntüleme modu:</span>
            {' '}
            <span className="font-bold">
              {impersonatedUser?.first_name} {impersonatedUser?.last_name}
            </span>
            {' '}
            <span className="opacity-75">
              ({impersonatedUser?.email})
            </span>
          </span>
          {impersonatedUser?.is_mentor && (
            <span className="px-2 py-0.5 bg-white/20 rounded-full text-xs">
              Mentor
            </span>
          )}
        </div>
        
        <div className="flex items-center gap-3">
          <span className="text-sm opacity-75 flex items-center gap-1">
            <Shield className="w-4 h-4" />
            {originalAdmin?.first_name} olarak giriş yapıldı
          </span>
          <button
            onClick={handleReturn}
            className="flex items-center gap-2 px-4 py-1.5 bg-white/20 hover:bg-white/30 rounded-lg transition font-medium text-sm"
          >
            <ArrowLeft className="w-4 h-4" />
            Admin'e Dön
          </button>
        </div>
      </div>
    </div>
  );
}
